export default "__VITE_ASSET__B29GZ4bt__"